import React, { useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import Container from "./Container";
import styled, { css } from "styled-components";
import TrustpilotMiniStarsIcon from "./Icons/TrustpilotMiniStars";
import { HtmlContent } from "./Content";

const USPsStyles = styled.div`
  ${({ ...props }) => css`
    background-color: ${props.theme.colors.lightGrey};
    padding: 16px 0;
    position: sticky;
    top: 0;
    z-index: 98;
    box-shadow: -4px 6px 11px -6px rgba(72, 72, 72, 0.26);
    transition: all ease 0.6s;

    .no-sticky-usp-bar & {
      position: initial
    }

    .hide-usp & {
      top: -57px;
    }

    ul {
      display: grid;
      grid-template-columns: 100% 100% 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scroll-snap-type: x mandatory;
  	  scroll-behavior: smooth;
      -ms-overflow-style: none;
		  scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      li {
        display: none;
        align-items: center;
        justify-content: center;
        scroll-snap-align: center;
        scroll-snap-stop: always;

        span {
          display: grid;
          place-items: center;
        }

        svg {
          margin-right: 16px;
          color: ${props.theme.colors.primary};
        }

        &:first-child,
        &:nth-child(2),
        &:nth-child(3) {
          display: flex;
          width: 100%;
        }
      }
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        li {
          &:first-child {
            width: auto;
          }

          &:nth-child(2) {
            width: auto;
          }

          &:nth-child(3) {
            width: auto;
          }
        }
      }
    }

    @media (min-width: ${props.theme.breakpoints.lg}) {
      ul {
        li {
          &:nth-child(4) {
            display: flex;

            a {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  `}
`;

export const UspBar = () => {
  const uspBarData = useStaticQuery(graphql`
    query UspBarQuery {
      wp {
        siteSettings {
          siteSettings {
            usps {
              icon
              text
            }
          }
        }
      }
      site {
        siteMetadata {
          trustpilotUrl
        }
      }
    }
  `);

  const { usps } = uspBarData.wp.siteSettings.siteSettings;

  const totalUsps = usps.length
  const uspSlider = useRef()
  
  function nextSlide() {
    let scrollToSlideIndex
    // Mobile devices don't seem to return a round number for this calculation, so we need to round it manually
    let currentSlideIndex = Math.round(uspSlider.current.scrollLeft / uspSlider.current.offsetWidth)
    if (currentSlideIndex === totalUsps - 1) {
      scrollToSlideIndex = 0
    } else {
      scrollToSlideIndex = currentSlideIndex + 1
    }
    uspSlider.current.scrollLeft = uspSlider.current.offsetWidth * scrollToSlideIndex
  }
  
  useEffect(() => {
    const interval = setInterval(nextSlide, 3000)
    return () => clearInterval(interval)
  }, [])

  return (
    <USPsStyles>
      <Container>
        <ul ref={uspSlider}>
          {usps.length > 0 &&
            usps.map((usp, index) => {
              return (
                <li key={index}>
                  {usp.icon && (
                    <span>
                      <HtmlContent htmlString={usp.icon} />
                    </span>
                  )}
                  <span>
                    <HtmlContent htmlString={usp.text} />
                  </span>
                </li>
              );
            })}
          <li>
            <a
              href={uspBarData.site.siteMetadata.trustpilotUrl}
              target="_blank"
              rel="noreferrer"
            >
              <TrustpilotMiniStarsIcon />
              Rated Excellent
            </a>
          </li>
        </ul>
      </Container>
    </USPsStyles>
  );
};
